export const WashingMachine: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1006_1121)">
        <mask
          id="mask0_1006_1121"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M0 7.62939e-06H80V80H0V7.62939e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1006_1121)">
          <path
            d="M20.2344 25.7811V5.85938L24.9219 1.17188H74.1406L78.8281 5.85938V74.1406L74.1406 78.8281H30.7812M20.2344 54.2188V28.1248"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M78.8281 5.85938H20.2344"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M78.8281 19.9219H20.2344"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M49.5312 68.9062C60.318 68.9062 69.0623 60.1619 69.0623 49.375C69.0623 38.5883 60.318 29.8438 49.5312 29.8438C38.7444 29.8438 30 38.5883 30 49.375C30 60.1619 38.7444 68.9062 49.5312 68.9062Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M60.8288 59.0153C63.0447 56.4209 64.3827 53.0544 64.3827 49.375C64.3827 41.1728 57.7334 34.5236 49.5313 34.5236C41.3289 34.5236 34.6797 41.1728 34.6797 49.375C34.6797 57.5773 41.3289 64.2266 49.5313 64.2266C53.2105 64.2266 56.5772 62.8884 59.1716 60.6725"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M34.6797 47.0312H47.1875L51.8748 51.7188H64.3827"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M71.7969 10.5469C73.0913 10.5469 74.1406 11.5962 74.1406 12.8906C74.1406 14.185 73.0913 15.2344 71.7969 15.2344C70.5025 15.2344 69.4531 14.185 69.4531 12.8906C69.4531 11.5962 70.5025 10.5469 71.7969 10.5469Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M62.4219 10.5469C63.7163 10.5469 64.7656 11.5962 64.7656 12.8906C64.7656 14.185 63.7163 15.2344 62.4219 15.2344C61.1275 15.2344 60.0781 14.185 60.0781 12.8906C60.0781 11.5962 61.1275 10.5469 62.4219 10.5469Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M53.0474 10.5469C54.3417 10.5469 55.3911 11.5962 55.3911 12.8906C55.3911 14.185 54.3417 15.2344 53.0474 15.2344C51.753 15.2344 50.7036 14.185 50.7036 12.8906C50.7036 11.5962 51.753 10.5469 53.0474 10.5469Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M24.9219 10.5469H38.9842V15.2344H24.9219V10.5469Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M54.8237 47.0312H64.1987"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M3.51562 71.7969L1.17188 74.1406V76.4844L3.51562 78.8281H24.9219L27.2656 76.4844V74.1406L24.9219 71.7969"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M10.5469 71.7969H24.9219L27.2656 69.4531V67.1094L24.9219 64.7656H3.51562L1.17188 67.1094V69.4531L3.51562 71.7969H8.20312"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M24.9219 64.7656L27.2656 62.4219V60.0781L24.9219 57.7344H3.51562L1.17188 60.0781V62.4219L3.51562 64.7656"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M67.1094 74.1406H78.8281"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
          <path
            d="M33.125 75.3125H30.7812M37.8125 75.3125H35.4688M65.9378 24.6094H75.3127M61.2503 24.6094H63.5941"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="22.926"
          />
        </g>
      </g>
    </svg>
  );
};
